import "../../assets/css/product.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import newsPaperSvg from "../../assets/images/icons/news_paper.svg";
import { useSearchParams } from "react-router-dom";
import { useDonationModal } from "../../hooks/use_donation_modal";
import DonationModalContainer from "../../components/modal/donate_modal_container";
import { useSubSalesValidation } from "../../hooks/use_sub_sales_validation";

function ProductPage() {
  const [searchParams] = useSearchParams();
  const kdBusiness = searchParams.get("kd_business");
  const userRef = searchParams.get("usridx");

  const donationModal = useDonationModal();

  useSubSalesValidation(kdBusiness);

  return (
    <div className="product-container">
      <Header />

      <section className="subscription-section">
        <div className="subscription-container">
          <h2 className="section-title">구독권 선택</h2>
          <div className="subscription-grid">
            <div className="subscription-card dark mobile">
              <div className="card-header">
                <h3>12개월 • 추천</h3>
                <div className="price">
                  <div className="amount">120,000원</div>
                  <div className="final-amount">108,000원</div>
                  <div className="period">연 결제 • 10% 할인</div>
                </div>
              </div>
              <ul className="features-list">
                <li>✓ 모든 뉴스 콘텐츠 무제한</li>
                <li>✓ Insight AI 기능</li>
                <li>✓ 브레인랩 (문해력•수해력)</li>
                <li>
                  ✓ <strong>월 9,000원</strong> (12개월)
                </li>
              </ul>
              <button
                className="subscribe-btn blue"
                onClick={() => {
                  donationModal.startDonationProcess("4");
                }}
              >
                결제하기
              </button>
            </div>

            <div className="subscription-card light month1">
              <div className="card-header">
                <h3>1개월</h3>
                <div className="price">
                  <div className="amount">10,000원</div>
                  <div className="period">월 결제</div>
                </div>
              </div>
              <ul className="features-list">
                <li>✓ 모든 뉴스 콘텐츠 무제한</li>
                <li>✓ Insight AI 기능</li>
                <li>✓ 브레인랩 (문해력•수해력)</li>
                <li>✓ 부모(보호자)와 자녀 계정 연동 기능 (최대 3명)</li>
              </ul>
              <button
                className="subscribe-btn blue"
                onClick={() => {
                  console.log(12);
                  donationModal.startDonationProcess("1");
                }}
              >
                결제하기
              </button>
            </div>

            <div className="subscription-card light month3">
              <div className="card-header">
                <h3>3개월</h3>
                <div className="price">
                  <div className="amount">30,000원</div>
                  <div className="period">분리 결제</div>
                </div>
              </div>
              <ul className="features-list">
                <li>✓ 모든 뉴스 콘텐츠 무제한</li>
                <li>✓ Insight AI 기능</li>
                <li>✓ 브레인랩 (문해력•수해력)</li>
                <li>✓ 부모(보호자)와 자녀 계정 연동 기능 (최대 3명)</li>
              </ul>
              <button
                className="subscribe-btn blue"
                onClick={() => {
                  donationModal.startDonationProcess("2");
                }}
              >
                결제하기
              </button>
            </div>

            <div className="subscription-card dark desktop">
              <div className="card-header">
                <h3>12개월 • 추천</h3>
                <div className="price">
                  <div className="amount">120,000원</div>
                  <div className="final-amount">108,000원</div>
                  <div className="period">연 결제 • 10% 할인</div>
                </div>
              </div>
              <ul className="features-list">
                <li>✓ 모든 뉴스 콘텐츠 무제한</li>
                <li>✓ Insight AI 기능</li>
                <li>✓ 브레인랩 (문해력•수해력)</li>
                <li>
                  ✓ <strong>월 9,000원</strong> (12개월)
                </li>
              </ul>
              <button
                className="subscribe-btn blue"
                onClick={() => {
                  donationModal.startDonationProcess("4");
                }}
              >
                결제하기
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="campaign-section">
        <div className="campaign-container">
          <h2 className="section-title">NIE 기부 캠페인</h2>
          <div className="campaign-cards">
            <div className="campaign-intro-card">
              <div className="campaign-intro-box">
                <div className="campaign-badge">함께 만드는 교육 나눔</div>
                <h3 className="campaign-intro-title">NIE 기부 캠페인 소개</h3>
                <p className="campaign-intro-description">
                  키즈다 NIE 캠페인은 교육, 학습, 문화콘텐츠로부터 소외된
                  도서산간 지역, 다문화가정, 저소득층 어린이에게 세상을 보는
                  시각을 넓혀주는 신문 구독을 장려해 기업과 독지가의
                  사회공헌활동 목적을 극대화시키고 편의를 돕습니다. 키즈다 NIE
                  캠페인은 사회공헌의 일환으로 어린이에게 키즈다를 보냄으로써
                  참된 ‘교육기부'를 실천하는 기부캠페인 입니다.
                </p>
              </div>
              <div className="campaign-intro-image">
                <img src={newsPaperSvg} alt="NIE 캠페인" />
              </div>
            </div>

            <div className="campaign-donate-card">
              <h3 className="campaign-donate-title">NIE 기부 참여하기</h3>
              <p className="campaign-donate-description">
                직접 결제로 키즈다 구독권을 기부하실수 있습니다.
              </p>
              <button
                className="campaign-donate-btn"
                onClick={() => {
                  donationModal.startDonationProcess("0");
                }}
              >
                기부하기
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="terms-container">
          <div className="terms-card">
            <h2 className="terms-title">서비스 이용 유의사항</h2>
            <ul className="terms-list">
              <li>상기금액은 부가세 포함된 금액입니다.</li>
              <li>
                구입하신 구독권은 결제내역 페이지에서 확인할 수 있습니다.{" "}
                <a href="/product_step1" className="terms-link">
                  결제내역 바로가기
                </a>
              </li>
              <li>
                기부내역은 기부내역 페이지에서 확인할 수 있습니다.{" "}
                <a href="/donation_step1" className="terms-link">
                  기부내역 바로가기
                </a>
              </li>
              <li>
                결제 완료 시 인증하신 휴대폰번호로 즉시 구독권이 발송됩니다.
              </li>
              <li>
                구입하신 구독권은 어린이동아 앱내 'My &gt; 쿠폰 등록 페이지에서
                사용할 수 있습니다.
              </li>
              <li>
                유료 구독 서비스 특성상, 이미 제공된 콘텐츠에 대해서는 환불이
                제한될 수 있습니다.
                <br />
                환불은 고객의 신청일 기준 이용 여부 및 남은 기간을 고려하여
                합리적으로 산정됩니다.
                <br />
                결제일 기준 초기 일정 기간내 환불요청이 있을 경우, 콘텐츠 미이용
                시 전액 환불을 원칙으로 합니다.
                <br />
                환불시 평가기준 월 단위 사용료를 차감한 후 잔여 금액을
                반환합니다. (할인 금액은 환불 대상에서 제외)
                <br />
                <a href="/application/service" className="terms-link">
                  환불정책 바로가기
                </a>{" "}
                자세한 환불정책을 확인하실 수 있습니다.
              </li>
              <li>
                유료 사용자에게 제공된 기능은 이용 기간만료 후에는 사용할 수
                없습니다.
              </li>
            </ul>
          </div>
        </div>
      </section>
      <Footer />

      <DonationModalContainer
        {...donationModal}
        kdBusiness={kdBusiness}
        userRef={userRef}
        paymentType="card"
      />
    </div>
  );
}

export default ProductPage;
